import { Box, useTheme } from "@mui/material";
import React from "react";
import InterviewSelectionAndOperate from "./top-nav/interview-selection-operate";
import DiscoveryLayoutShiftingNav from "./top-nav/layout-shifting-nav";
import InterviewPublishAndTemplate from "./top-nav/interview-publish-and-template";

const DiscoveryTopNav = (props) => {
  const {
    isPublishing,
    allInterview,
    openInterviewListDrawer,
    publishInterview,
    setOpenInterviewListDrawer,
    setAnchorEl,
    selectedTab,
    setSelectedTab
  } = props;

  const theme = useTheme();

  return (
    <Box
      sx={{
        border: `1px solid ${theme.custom.borderGrey}`,
        borderTop: "none",
        background: "white",
        padding: "7px 12px",
        marginBottom: "12px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{width:"33%"}}>
        <InterviewSelectionAndOperate
          openInterviewListDrawer={openInterviewListDrawer}
          setOpenInterviewListDrawer={setOpenInterviewListDrawer}
          allInterview={allInterview}
          setAnchorEl={setAnchorEl}
        />
      </Box>
      <Box sx={{width:"34%",display:"flex",justifyContent:"center"}}>
        <DiscoveryLayoutShiftingNav 
         selectedTab={selectedTab}
         setSelectedTab={setSelectedTab}
        />
      </Box>
      <Box sx={{width:"33%"}}>
        <InterviewPublishAndTemplate
          publishInterview={publishInterview}
          isPublishing={isPublishing}
        />
      </Box>
    </Box>
  );
};

export default DiscoveryTopNav;
